<div class="auto-search-datetime">
  <div class="auto-calendar-inputs">
    <div class="auto-calendar-input departure">
      <app-search-bar-input
              [isMobile]="isMobile"
              [searchType]="searchType"
              [label]="'AUTOS_MODULE.SEARCH.FROM' | transloco"
              [placeholder]="'AUTOS_MODULE.SEARCH.DATE' | transloco"
              [value]="pickUpDate | autoSearchDate"
              [icon]="icons.Calendar"
              [swapPlaceholder]="true"
              [readOnly]="true"
              [showError]="isPickUpDateEmpty"
              (isFocus)="showMobileCalendar(calendarField.departure)">
      </app-search-bar-input>
    </div>
    <div class="auto-time-input departure">
    <app-search-bar-mobile-timepicker
              id="autos_time-from"
              [isMobile]="isMobile"
              [searchType]="searchType"
              [value]="pickUpTime"
              [label]="'AUTOS_MODULE.SEARCH.TIME' | transloco"
              [placeholder]="'AUTOS_MODULE.SEARCH.TIME' | transloco"
              [title]="'AUTOS_MODULE.SEARCH.ORIGIN_TIME' | transloco"
              [showError]="isPickUpTimeEmpty"
              (timeSelection)="updateTime($event, timeField.departure)"
              [isHome]="true"
              [disabled]="isEmptyDate(pickUpDate)">
      </app-search-bar-mobile-timepicker>
    </div>
  </div>
  <div class="auto-calendar-inputs">
    <div class="auto-calendar-input arrival">
      <app-search-bar-input
              [isMobile]="isMobile"
              [searchType]="searchType"
              [label]="'AUTOS_MODULE.SEARCH.TO' | transloco"
              [placeholder]="'AUTOS_MODULE.SEARCH.DATE' | transloco"
              [value]="dropOffDate | autoSearchDate"
              [icon]="icons.Calendar"
              [swapPlaceholder]="true"
              [readOnly]="true"
              [showError]="isDropOffDateEmpty"
              (isFocus)="showMobileCalendar(calendarField.arrival)">
      </app-search-bar-input>
    </div>
    <div class="auto-time-input arrival">
      <app-search-bar-mobile-timepicker
              id="autos_time-to"
              [isMobile]="isMobile"
              [searchType]="searchType"
              [value]="dropOffTime"
              [label]="'AUTOS_MODULE.SEARCH.TIME' | transloco"
              [placeholder]="'AUTOS_MODULE.SEARCH.TIME' | transloco"
              [title]="'AUTOS_MODULE.SEARCH.RETURN_TIME' | transloco"
              [showError]="isDropOffTimeEmpty"
              (timeSelection)="updateTime($event, timeField.arrival)"
              [isHome]="true"
              [disabled]="isEmptyDate(dropOffDate)">
      </app-search-bar-mobile-timepicker>
    </div>
  </div>
</div>
